module.exports = __webpack_public_path__ + "static/media/detectDataImage9_en.b964b31c.png";